import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { PoliciesService } from "app/main/admin/politica-de-compliance/politica-de-compliance.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-dropdown",
  templateUrl: "./dropdown.component.html",
  styleUrls: ["./dropdown.component.scss"],
})
export class DropdownComponent {
  @Input() dados;
  @Output() hasClientDelete = new EventEmitter<any>();

  constructor(
    public policiesService: PoliciesService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  redirectVisualizar() {
    this.router.navigateByUrl("/admin/politicas/visualizar", {
      state: {
        id: this.dados.id,
        titulo: this.dados.titulo
      },
    });
  }

  redirectAtualizar() {
    this.router.navigateByUrl(
      "/admin/politicas/atualizar-politica-de-compliance",
      {
        state: {
          id: this.dados.id,
          versao: this.dados.versoes[this.dados.versoes.length - 1].versao,
          titulo: this.dados.titulo,
          codigo: this.dados.versoes[0].codigo,
          midiaNome: this.dados.versoes[0].midiaNome,
          midiaCaminho: this.dados.versoes[0].midiaCaminho,
          midiaMimeType: this.dados.versoes[0].midiaMimeType,
          midiaId: this.dados.versoes[0].midiaId,
          icone: this.dados.icone,
          publicado: this.dados.versoes[this.dados.versoes.length - 1].publicado,
          dataEmissao: this.dados.versoes[0].dataEmissao,
          ativo: this.dados.ativo,
          publico: this.dados.publico,
          areas: this.dados.areas,
          grupos: this.dados.grupos
        },
      }
    );
  }

  async deletar() {
    let result = await this.policiesService.deletePolices(this.dados.id);

    if(result.codeId === 200) {
      // this.toastr.success('Sua deleção foi feita com sucesso!');
      this.hasClientDelete.emit();
    } else {
      // this.toastr.error('Não foi possível deletar o cliente');
    }
  }
}
